@if (filterValues(); as filterValuesArray) { @for (filterValue of filterValuesArray; track
filterValue + '_' + $index) {
<base-checkbox-filter [isChecked]="filterValue?.checked || false" [type]="type() || 'checkbox'" (checked)="selectFilter(filterValue)" [label]="(filterValue?.value?.split('-')?.[0] || '')" [labelPadding]="true" [doc_count]="filterValue?.doc_count || 0">
    <span class="color-swatch" [ngStyle]="{ background: filterValue?.value?.split('-')?.[1] || '' }"></span>
</base-checkbox-filter>
} }